// extracted by mini-css-extract-plugin
module.exports = {"bnplPromo":"BuyNowPayLaterPromo_bnplPromo__h2XJk","paymentMethodMessagingElement":"BuyNowPayLaterPromo_paymentMethodMessagingElement__A6SBk"};